const NAVIGATION_LOCK_KEY = 'netuno-navigation-lock';
const NAVIGATION_LOCK_COOLDOWN_MS = 1500;

let inFlightNavigation = false;

type RedirectMode = 'spa' | 'location-replace' | 'reload';

type NavigationLockState = {
  at: number;
  by: string;
  to: string;
  mode: RedirectMode;
};

function readLockState(): NavigationLockState | null {
  try {
    const raw = sessionStorage.getItem(NAVIGATION_LOCK_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as NavigationLockState;
  } catch {
    return null;
  }
}

function writeLockState(state: NavigationLockState) {
  try {
    sessionStorage.setItem(NAVIGATION_LOCK_KEY, JSON.stringify(state));
  } catch {
    // storage may be unavailable
  }
}

function acquireNavigationLock(by: string, to: string, mode: RedirectMode): boolean {
  const now = Date.now();
  const existing = readLockState();

  if (inFlightNavigation) {
    console.warn('[NetUno:router] redirect blocked by in-memory lock', { by, to, mode });
    return false;
  }

  if (existing && now - existing.at < NAVIGATION_LOCK_COOLDOWN_MS) {
    console.warn('[NetUno:router] redirect blocked by cooldown lock', {
      by,
      to,
      mode,
      lockedBy: existing.by,
      lockedTo: existing.to,
      lockAgeMs: now - existing.at,
    });
    return false;
  }

  inFlightNavigation = true;
  writeLockState({ at: now, by, to, mode });

  console.log('[NetUno:router] redirect triggered by', by, 'to', to);

  window.setTimeout(() => {
    inFlightNavigation = false;
  }, 300);

  return true;
}

export function requestSpaRedirect(by: string, to: string): boolean {
  return acquireNavigationLock(by, to, 'spa');
}

export function requestLocationReplace(by: string, to: string): boolean {
  return acquireNavigationLock(by, to, 'location-replace');
}

export function requestHardReload(by: string): boolean {
  return acquireNavigationLock(by, window.location.href, 'reload');
}
